import { AfterViewInit, Component, OnInit, Inject, PLATFORM_ID, Renderer2 } from '@angular/core'

import { Title, Meta } from '@angular/platform-browser'
import { CommonModule, isPlatformBrowser } from '@angular/common'
import { PlansService } from '../../services/plans.service'
import { RouterModule, Router } from '@angular/router'
import { map, Observable, tap } from 'rxjs'
import { ParsedFeature, parseFeatureLine } from '../../utils/feature-parser'
import { SeoService } from '../../services/seo.service'
import { HomeService } from '../../services/home.service'
import { ToastrService } from 'ngx-toastr'
import { environment } from '../../../environments/environment'

declare var $: any
declare const AOS: any
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, AfterViewInit {
  monthlyPlans: any[] = []
  annualPlans: any[] = []

  selectedType: 'monthly' | 'yearly' = 'monthly'
  displayedPlans: any[] = []
  allPlans: any[] = []
  plans$!: Observable<any[]>
  featuresList: ParsedFeature[] = []
  isLoading = false
  mode: 'trial' | 'buy' = 'trial'
  planId!: string
  private aosInitialized = false
  countries: any[] = []

  constructor(
    private title: Title,
    private meta: Meta,
    private planService: PlansService,
    private homeService: HomeService,
    private toastr: ToastrService,
    private router: Router,
    private renderer: Renderer2,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.title.setTitle('AVR HRMS - Human Resource Management System')

    this.meta.updateTag({
      name: 'description',
      content: 'AVR HRMS - Payroll, attendance, employee management system'
    })
    this.meta.updateTag({
      name: 'keywords',
      content: 'HRMS, Payroll, Attendance, Employee Management, Leave Management'
    })

    this.meta.updateTag({
      property: 'og:title',
      content: 'AVR HRMS - Human Resource Management System'
    })

    this.meta.updateTag({
      property: 'og:description',
      content: 'AVR HRMS - Payroll, attendance, employee management system'
    })

    this.meta.updateTag({
      property: 'og:type',
      content: 'website'
    })

    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image'
    })

    this.meta.updateTag({
      name: 'twitter:title',
      content: 'AVR HRMS - Human Resource Management System'
    })

    this.meta.updateTag({
      name: 'twitter:description',
      content: 'AVR HRMS - Payroll, attendance, employee management system'
    })
    if (isPlatformBrowser(this.platformId)) {
      this.seoService.updateCanonical(window.location.href)
    }
    this.loadPlans()
    this.loadCountries()
  }

  ngAfterViewInit(): void {
    // ✅ SSR SAFE CHECK
    if (!isPlatformBrowser(this.platformId)) return

    setTimeout(() => {
      const el = $('.features-slider')

      if (el.length > 0 && (el as any).owlCarousel) {
        el.owlCarousel({
          margin: 30,
          dots: false,
          nav: true,
          navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
          loop: true,
          responsive: {
            0: { items: 1 }
          }
        })
      }
    }, 300)

    // setTimeout(() => {
    //   AOS.init({
    //     once: true,
    //     duration: 1000
    //   })
    // }, 300)
    this.ensureAOS()
    window.addEventListener(
      'load',
      () => {
        ;(window as any).AOS?.refreshHard()
      },
      { once: true }
    )
  }

  // loadPlans() {
  //   this.planService
  //     .getRegisterPlans({
  //       // type,
  //       status: 'active',
  //       page: 1,
  //       limit: 12
  //     })
  //     .subscribe({
  //       next: res => {
  //         this.displayedPlans = res.plans
  //       },
  //       error: err => {
  //         console.error(err)
  //       }
  //     })
  // }

  // changePlanType(type: 'monthly' | 'yearly') {
  //   this.selectedType = type
  //   this.loadPlans(type)
  // }

  // loadPlans() {
  //   this.planService.getRegisterPlans({ status: 'active', page: 1, limit: 12 }).subscribe({
  //     next: (res: any) => {
  //       this.allPlans = res.plans || res
  //       this.filterPlans()
  //     },
  //     error: err => {
  //       console.error('Failed to load plans', err)
  //     }
  //   })
  // }

  // loadPlans() {
  //   this.plans$ = this.planService
  //     .getRegisterPlans({
  //       // type: this.selectedType,
  //       status: 'active',
  //       page: 1,
  //       limit: 12
  //     })
  //     .pipe(map(res => res.plans || []))
  // }

  // loadPlans() {
  //   this.plans$ = this.planService
  //     .getRegisterPlans({
  //       status: 'active',
  //       page: 1,
  //       limit: 100
  //     })
  //     .pipe(
  //       map(res => res.plans || []),
  //       map(plans =>
  //         plans.map(plan => ({
  //           ...plan,
  //           featuresList: buildFeatureTree(plan)
  //         }))
  //       ),
  //       tap(() => {
  //         setTimeout(() => {
  //           if (typeof AOS !== 'undefined') {
  //             AOS.refreshHard()
  //           }
  //         }, 300)
  //       })
  //     )
  // }

  loadPlans() {
    this.isLoading = true

    this.planService
      .getRegisterPlans({
        status: 'active',
        page: 1,
        limit: 100
      })
      .subscribe({
        next: res => {
          this.allPlans = (res.plans || []).map(plan => ({
            ...plan,
            featuresList: buildFeatureTree(plan)
          }))

          this.filterPlans()
          this.isLoading = false
          // setTimeout(() => {
          //   AOS.init({
          //     once: true,
          //     duration: 1000
          //   })
          // })
        },
        error: err => {
          console.error(err)
          this.isLoading = false
        }
      })
  }

  filterPlans() {
    this.displayedPlans = this.allPlans.filter(plan => plan.type === this.selectedType)
    this.aosRefresh()
  }

  changePlanType(type: 'monthly' | 'yearly') {
    this.selectedType = type
    this.filterPlans()
    // setTimeout(() => {
    //   AOS.init({
    //     once: true,
    //     duration: 1000
    //   })
    // })

    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        // AOS.refresh() // ONLY THIS
        this.ensureAOS()
      }, 100)
    }
  }

  loadFeatures(lines: string[]) {
    this.featuresList = lines.map(line => parseFeatureLine(line))
  }

  goToBuy(id: string, mode: 'trial' | 'buy') {
    this.mode = mode
    this.isLoading = false
    window.dispatchEvent(new Event('resize'))
    // this.router.navigate(['/app/auth/register', id], { queryParams: { mode: this.mode } })
    // window.open(`/app/auth/register/${id}?mode=${this.mode}`, '_blank')
    window.location.href = `${environment.appUrl}/auth/register/${id}?mode=${this.mode}`
  }
  // goToBuy(id: string) {
  //   const url = this.router.serializeUrl(
  //     this.router.createUrlTree(['/app/auth/register', id], {
  //       queryParams: { mode: this.mode }
  //     })
  //   )

  //   window.open(url, '_blank')
  // }

  private aosRefresh() {
    if (!isPlatformBrowser(this.platformId)) return

    // setTimeout(() => {
    //   requestAnimationFrame(() => {
    //     AOS.refresh()
    //   })
    // }, 50)
    this.ensureAOS()
  }

  /**
   * Single safe entrypoint — jab bhi AOS chahiye ho, ise call karo.
   * Agar init nahi hua to init karega, agar ho chuka hai to refreshHard karega.
   * Retry-limit ko generous rakha (40 × 200ms = 8 second window).
   */
  private ensureAOS(retries = 40, delayMs = 200): void {
    const aos = (window as any).AOS

    if (aos) {
      if (!this.aosInitialized) {
        aos.init({ once: true, duration: 1000 })
        this.aosInitialized = true
      } else {
        aos.refreshHard()
      }
    } else if (retries > 0) {
      setTimeout(() => this.ensureAOS(retries - 1, delayMs), delayMs)
    } else {
      console.warn('AOS load nahi hui — max retries khatam')
    }
  }

  submitInquiry(payload: { name: string; email: string; countryCode: string; phone: string }) {
    this.homeService.submitInquiry(payload).subscribe({
      next: res => {
        this.toastr.success(res.message || 'Inquiry submitted successfully', 'Success')

        const form = document.getElementById('inquiryForm') as HTMLFormElement
        form?.reset()

        const countryCode = document.getElementById('countryCodeInput') as HTMLInputElement
        if (countryCode) {
          countryCode.value = ''
        }
      },
      error: err => {
        this.toastr.error(err.error?.message || 'Something went wrong', 'Error')
        alert(err.error?.message || 'Something went wrong')
      }
    })
  }

  onSubmit(event: Event) {
    event.preventDefault()

    const form = event.target as HTMLFormElement

    const payload = {
      name: (form.querySelector('#inqName') as HTMLInputElement).value.trim(),
      email: (form.querySelector('#inqEmail') as HTMLInputElement).value.trim(),
      countryCode: (form.querySelector('#countryCodeInput') as HTMLInputElement).value.trim(),
      phone: (form.querySelector('#inqPhone') as HTMLInputElement).value.trim()
    }

    this.submitInquiry(payload)
  }

  loadCountries() {
    this.homeService.getCountries().subscribe({
      next: res => {
        this.countries = res.countries || []

        this.initializeCountryDropdown()
      },
      error: err => {
        console.error(err)
      }
    })
  }

  initializeCountryDropdown() {
    setTimeout(() => {
      const searchInput = document.getElementById('countrySearch') as HTMLInputElement
      const hiddenInput = document.getElementById('countryCodeInput') as HTMLInputElement
      const dropdown = document.querySelector('#countryDropdown .dropdown-list') as HTMLElement

      if (!searchInput || !dropdown || !hiddenInput) {
        return
      }

      dropdown.innerHTML = ''

      this.countries.forEach(country => {
        const item = document.createElement('div')

        item.className = 'dropdown-item'

        // item.innerText = `${country.iso3} (+${country.phonecode})`
        // item.innerHTML = `
        //   <div style="display:flex;align-items:center;gap:8px;">
        //     <img
        //       src="https://flagcdn.com/24x18/${country.iso2.toLowerCase()}.png"
        //       width="24"
        //       height="18"
        //       alt="${country.iso2}"
        //     />
        //     <span>${country.iso3} (+${country.phonecode})</span>
        //   </div>
        // `

        item.onclick = () => {
          searchInput.value = `${country.iso3} (+${country.phonecode})`
          hiddenInput.value = `+${country.phonecode}`
          dropdown.style.display = 'none'
        }

        dropdown.appendChild(item)
      })

      searchInput.addEventListener('focus', () => {
        dropdown.style.display = 'block'
      })

      searchInput.addEventListener('input', () => {
        const value = searchInput.value.toLowerCase()

        Array.from(dropdown.children).forEach(child => {
          const element = child as HTMLElement

          element.style.display = element.innerText.toLowerCase().includes(value) ? 'block' : 'none'
        })
      })

      document.addEventListener('click', e => {
        if (!(e.target as HTMLElement).closest('#countryDropdown')) {
          dropdown.style.display = 'none'
        }
      })
    })
  }
}

export const buildFeatureTree = (plan: any): ParsedFeature[] => {
  const features: ParsedFeature[] = []

  if (plan.description?.trim()) {
    plan.description
      .split('\n')
      .filter((l: string) => l.trim())
      .forEach((line: string) => {
        features.push(parseFeatureLine(line))
      })
  } else if (plan.modules?.length) {
    plan.modules.forEach((pm: any) => {
      const children = pm.module?.dependencies?.length
        ? pm.module.dependencies.map((dep: any) =>
            parseFeatureLine(`[+] ${dep.dependsOnModule?.name || ''}`)
          )
        : []

      features.push({
        text: formatModuleName(pm.module?.name || 'Unnamed Module'),
        isFeature: true,
        icon: 'ti-check',
        colorClass: 'text-success',
        children
      })
    })
  }

  return features
}
export const formatModuleName = (value: string): string => {
  if (!value) return ''

  // Insert space before each uppercase letter
  const withSpaces = value.replace(/([A-Z])/g, ' $1')

  // Capitalize each word (title case)
  return withSpaces.replace(/\b\w/g, char => char.toUpperCase()).trim()
}
